import {
  useFavoriteGamesStore,
  useGameToastStore,
  useGamesStore,
  useMaintenanceGamesStore,
  useModalsStore,
  usePackageStore,
  usePaymentStore,
  usePromotionStore,
  useUserBankStore,
  useUserPromotionStore,
  useUserStore,
} from '#lib/stores'

/**
 * Provides methods to reset Pinia stores.
 * @returns An object with methods to reset stores.
 * @namespace
 */
export function useResetStore() {
  const favoriteGameStore = useFavoriteGamesStore()
  const gameToastStore = useGameToastStore()
  const gamesStore = useGamesStore()
  const maintenanceGamesStore = useMaintenanceGamesStore()
  const modalsStore = useModalsStore()
  const packageStore = usePackageStore()
  const paymentStore = usePaymentStore()
  const promotionStore = usePromotionStore()
  const userBankStore = useUserBankStore()
  const userPromotionStore = useUserPromotionStore()
  const userStore = useUserStore()

  const resetAll = () => {
    favoriteGameStore.$reset()
    gameToastStore.$reset()
    gamesStore.reset()
    maintenanceGamesStore.$reset()
    modalsStore.$reset()
    packageStore.$reset()
    paymentStore.$reset()
    promotionStore.$reset()
    userBankStore.$reset()
    userPromotionStore.$reset()
    userStore.$reset()
  }

  return {
    resetAll,
  }
}
